import React, { useRef, useState } from 'react';
import Image from 'next/image';
import {
  ApartmentGalleryContainer,
  GalleryImg,
  SliderTrack,
  Slide,
  Thumbnails,
  Thumb,
  Counter
} from './styled';
import { Photo } from '../../../../../graphql/types';
import useScreenSize from '../../../../../hooks/useScreenSize';

interface ApartmentsGalleryProps {
  photos: Photo[];
  imgAlt: string;
}

export const ApartmentsGallery: React.FC<ApartmentsGalleryProps> = ({
  photos,
  imgAlt
}) => {
  const { isSmallOrLargeDesktop } = useScreenSize();
  const [activeIndex, setActiveIndex] = useState(0);
  const [isZoomed, setIsZoomed] = useState(false);
  const thumbsRef = useRef<HTMLDivElement | null>(null);

  const scrollToCenter = (index: number) => {
    const container = thumbsRef.current;
    const el = container?.children[index] as HTMLElement;

    if (!container || !el) return;

    const containerWidth = container.clientWidth;
    const elLeft = el.offsetLeft;
    const elWidth = el.offsetWidth;

    const scrollTo = elLeft - containerWidth / 2 + elWidth / 2;

    container.scrollTo({
      left: scrollTo,
      behavior: 'smooth'
    });
  };

  const handleThumbClick = (index: number) => {
    setActiveIndex(index);
    scrollToCenter(index);
  };

  const handleZoomToggle = () => {
    if (!isSmallOrLargeDesktop) return;
    setIsZoomed(prev => !prev);
  };

  const filteredPhotos = photos.filter(photo => photo?.f660x496);

  return (
    <ApartmentGalleryContainer>
      <GalleryImg $isZoomed={isZoomed} data-cy="apartments-modal-gallery-img">
        <SliderTrack $index={activeIndex}>
          {filteredPhotos.map((photo, i) => (
            <Slide key={`main-photo-${i}`} onClick={handleZoomToggle}>
              <Image
                src={photo.f660x496}
                alt={imgAlt}
                width={375}
                height={245}
              />
            </Slide>
          ))}
        </SliderTrack>
        {filteredPhotos.length > 1 && (
          <Counter>
            {activeIndex + 1}/{filteredPhotos.length}
          </Counter>
        )}
      </GalleryImg>

      {filteredPhotos.length > 1 && (
        <Thumbnails ref={thumbsRef}>
          {filteredPhotos.map((photo, i) => (
            <Thumb
              key={`thumb-photo-${i}`}
              onClick={() => handleThumbClick(i)}
              $active={i === activeIndex}
            >
              <img src={photo.f660x496} alt={imgAlt} />
            </Thumb>
          ))}
        </Thumbnails>
      )}
    </ApartmentGalleryContainer>
  );
};
